import React from 'react';
import LegalPage from './LegalPage';

const Safety: React.FC = () => <LegalPage documentId="safety" />;

export default Safety;
